import React from 'react';
import { ArrowDownCircle } from 'react-feather';
import store from '../../../redux';
const Download = ({ audioName }) => {
  const downloadUrl = `${process.env.REACT_APP_API_URL}/downloadwav?wav_name=`;

  const userToken = store.getState().auth.login.data.access_token;
  const token = `Bearer ${userToken}`;
  // const downloadAudio = () => {
  //   const url = downloadUrl + audioName;
  //   fetch(url, {
  //     method: 'GET',
  //     headers: {
  //       Authorization: token
  //     }
  //   })
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       let url = window.URL.createObjectURL(blob);
  //       const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  //       if (newWindow) newWindow.opener = null;
  //     });
  // };

  const downloadAudio = () => {
    const url = process.env.REACT_APP_API_BASE_URL + '/downloadwav?wav_name=' + audioName;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const newWindow = window.open(url, audioName, 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      });
  };

  return (
    <ArrowDownCircle
      size={20}
      color="#4A5568"
      onClick={downloadAudio}
      className="cursor-pointer text-gray-500 hover:text-gray-700"
      download
      target="_blank"
    />
  );
};

export default Download;
